import ContentfulStory from "models/data/contentful/ContentfulStory";
import ContentfulToApiImage from "models/data/mappings/ContentfulToApiImage";
import ContentfulToApiAuthor from "models/data/mappings/ContentfulToApiAuthor";
import ContentfulToApiTextEssay from "models/data/mappings/ContentfulToApiTextEssay";
import ContentfulToApiCategory from "./ContentfulToApiCategory";

class ContentfulToApiStory {
  static apiFeaturedImage = (contentfulStory) => {
    const contentfulImage = ContentfulStory.featuredImage(contentfulStory);
    return ContentfulToApiImage.map(contentfulImage);
  };

  static apiAuthor = (contentfulStory) => {
    const contentfulAuthor = ContentfulStory.author(contentfulStory);
    return ContentfulToApiAuthor.map(contentfulAuthor);
  };

  static apiTextEssay = (contentfulStory) => {
    const contentfulTextEssay = ContentfulStory.textEssay(contentfulStory);
    return ContentfulToApiTextEssay.map(contentfulTextEssay);
  };

  static apiCategories = (contentfulStory) => {
    const categories = ContentfulStory.categories(contentfulStory);
    return categories.map((category) => ContentfulToApiCategory.map(category));
  };

  static apiAuthorMultiple = (contentfulStory) => {
    const contentfulAuthors = ContentfulStory.authorMultiple(contentfulStory);
    return contentfulAuthors.map((contentfulAuthor) =>
      ContentfulToApiAuthor.map(contentfulAuthor)
    );
  };

  static apiRelatedStories = async (contentfulStory) => {
    const relatedStories = ContentfulStory.relatedStories(contentfulStory);
    const relatedStoryIds = relatedStories.map((relatedStory) =>
      ContentfulStory.id(relatedStory)
    );
    const fullRelatedStories = [];
    for (let i = 0; i < relatedStoryIds.length; i++) {
      const relatedStoryId = relatedStoryIds[i];
      const story = await ContentfulStory.fetch(relatedStoryId);
      fullRelatedStories.push(story);
    }

    return fullRelatedStories.map((relatedStory) => ({
      id: ContentfulStory.id(relatedStory),
      title: ContentfulStory.title(relatedStory),
      slug: ContentfulStory.slug(relatedStory),
      summary: ContentfulStory.summary(relatedStory),
      featuredImage: ContentfulToApiStory.apiFeaturedImage(relatedStory),
      author: ContentfulToApiStory.apiAuthor(relatedStory),
      publicationDate: ContentfulStory.publicationDate(relatedStory),
      authorMultiple: ContentfulToApiStory.apiAuthorMultiple(relatedStory),
      textEssay: ContentfulToApiStory.apiTextEssay(relatedStory),
      categories: ContentfulToApiStory.apiCategories(relatedStory),
    }));
  };

  static map = async (contentfulStory) => {
    const relatedStories = await ContentfulToApiStory.apiRelatedStories(
      contentfulStory
    );

    return {
      id: ContentfulStory.id(contentfulStory),
      title: ContentfulStory.title(contentfulStory),
      slug: ContentfulStory.slug(contentfulStory),
      summary: ContentfulStory.summary(contentfulStory),
      featuredImage: ContentfulToApiStory.apiFeaturedImage(contentfulStory),
      author: ContentfulToApiStory.apiAuthor(contentfulStory),
      authorMultiple: ContentfulToApiStory.apiAuthorMultiple(contentfulStory),
      publicationDate: ContentfulStory.publicationDate(contentfulStory),
      textEssay: ContentfulToApiStory.apiTextEssay(contentfulStory),
      categories: ContentfulToApiStory.apiCategories(contentfulStory),
      relatedStories,
    };
  };
}

export default ContentfulToApiStory;
